// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kpi-card-root {
    border-radius: 16px;
    /* max-width: 250px;
    min-width: 180px; */
    width: 100%;
}

.kpi-card-container {
    width: 100%;
    display: grid;
}

.kpi-amount {
    font-weight: 900;
}

.kpi-card {
    gap: 1rem;
    width: 100%;
    overflow-x: auto;
}

.recon-kpi-dropdowns {
    gap: 0.8rem
}

.footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 1rem;
    box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.15);
}

.filter-value-container {
    display: flex;
    align-items: center;
    /* justify-content: center; */
    gap: 1rem;
    flex-wrap: wrap;
}

.filter-value {
    border: 1px solid #ccc;
    padding: 0.2rem 0.9rem;
    border-radius: 20px;
    display: flex;
    align-items: center;
}

.filter-value-text {
    flex: 1;
    width: 150px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-weight: 500;
    /* display: flex;
    align-items: center; */
}

.tableData {
    margin-top: 1rem;
}

.filter-container {
    position: relative;
    padding: 0 1rem 0 0;
    white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/Reconciliation/Dashboard/style.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB;uBACmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB;0BACsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB","sourcesContent":[".kpi-card-root {\n    border-radius: 16px;\n    /* max-width: 250px;\n    min-width: 180px; */\n    width: 100%;\n}\n\n.kpi-card-container {\n    width: 100%;\n    display: grid;\n}\n\n.kpi-amount {\n    font-weight: 900;\n}\n\n.kpi-card {\n    gap: 1rem;\n    width: 100%;\n    overflow-x: auto;\n}\n\n.recon-kpi-dropdowns {\n    gap: 0.8rem\n}\n\n.footer {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 1rem;\n    box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.15);\n}\n\n.filter-value-container {\n    display: flex;\n    align-items: center;\n    /* justify-content: center; */\n    gap: 1rem;\n    flex-wrap: wrap;\n}\n\n.filter-value {\n    border: 1px solid #ccc;\n    padding: 0.2rem 0.9rem;\n    border-radius: 20px;\n    display: flex;\n    align-items: center;\n}\n\n.filter-value-text {\n    flex: 1;\n    width: 150px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    font-weight: 500;\n    /* display: flex;\n    align-items: center; */\n}\n\n.tableData {\n    margin-top: 1rem;\n}\n\n.filter-container {\n    position: relative;\n    padding: 0 1rem 0 0;\n    white-space: nowrap;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
